import React from 'react'

import Layout from '../layouts'
import Grid from '../components/elements/grid'
import { Body, SizedText } from '../components/elements/typography'

import { useForm, useFormState } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"
import { navigate } from 'gatsby'
import Icon from '../components/elements/icon'
import Botpoison from "@botpoison/browser"

import pickupIcon from '../theme/icons/pick-up.svg'
import mailIcon from '../theme/icons/mail.svg'

function encode(data) {
  return Object.keys(data)
      .map(
          key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      )
      .join('&')
}

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const schema = yup.object({
  firstName: yup.string()
    .required('Your first name is required.')
    .min(2, 'Please enter your first name.')
    .max(80, 'Please enter a valid name.'),
  lastName: yup.string()
    .required('Your last name is required.')
    .min(2, 'Please enter your last name.')
    .max(80, 'Please enter a valid name.'),
  phoneNumber: yup.string().matches(phoneRegExp, 'Phone number is not valid. (Format: 912-739-3322)')
    .min(10, 'Please include your area code.')
    .max(12, 'Please enter a valid phone number. (Format: 912-739-3322)'),
  cardNumber: yup.string()
    .required('Your current card number is required.')
    .matches(/^[0-9]+$/, "Must be numerical digits only.")
    .min(4, 'Must be exactly 4 digits')
    .max(4, 'Must be exactly 4 digits'),
  //pickup: yup.boolean().required().oneOf([0 , 1]),
  feeAck: yup.boolean().default(false).oneOf([true],"You must acknowledge the terms and conditions before continuing."),
           
}).required();

const OrderPage = () => {

  const { register, handleSubmit, watch, reset, formState: { errors, isSubmitted, isDirty, isValid } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema)
  })

  const onSubmit = (data, e) => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
            'form-name': 'card-order-form',
            ...data,
        }),
    })
        .then(response => {
            reset()
            navigate(form.getAttribute('action'))
            console.log(response)
        })
        .catch(error => {
            console.log(error)
        })
}

  return (
    <Layout isSubMenuOpen={false} forceRootMenu="/">
      <Grid.FullWidthSection css={{padding: `6rem 0`, alignItems: `center`}}>
        <Grid.Block start={[2,2,2,2,3,4]} span={[12,12,12,12,10,8]} css={{backgroundColor: `#fff`, overflow: `hidden`}}>
          <div css={{display: `grid`, gridTemplateColumns: `1fr 1fr 1fr 1fr`, 'div': {height: `0.702rem`},}}>
            <div css={{backgroundColor: `#00b4e5`}}></div><div css={{backgroundColor: `#0376bd`}}></div><div css={{backgroundColor: `#005ea8`}}></div><div css={{backgroundColor: `#192851`}}></div>
          </div>

          <div css={{ 
            padding: `4rem 2rem`,
            '@media (min-width: 1024px)': {
              padding: `4rem`
            }
          }}>
            <SizedText as="h1" smallSize="1.802" largeSize="3.653" css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`}}>
              Order Your New TCB Contactless Debit Card
            </SizedText>
            <hr />

            <Body css={{
              padding: `2rem 0`,
              textAlign: `justify`,
              '@media (min-width: 1024px)': {
                padding: `2rem`,
              }
            }}>
              Please complete the form below to order your new TCB Contactless MasterCard Debit Card today.  All form fields are required.  Please note, a TCB customer service representative will perform a callback on all order requests prior to processing the order.  
            </Body>


            <form 
              name="card-order-form"
              method="POST"
              action="https://submit-form.com/Xwlf1EZ6"
              data-botpoison-public-key="pk_24b4aca2-779b-4bc5-ab28-098eed007d28"
              css={{
                
                'form, input, label, textarea': {
                  boxSizing: `border-box`,
                  display: `block`,
                  textAlign: `left`,
                  //width: `100%`,
                },
                '.errorMessage': {
                  height: `1.5rem`,
                  paddingLeft: `1rem`,
                  color: ` #cc0000`
                }
              }}
            >

              <input
                type="hidden"
                name="_redirect"
                value="https://tcbga.bank/order-success"
              />

              <div css={{
                display: `grid`, 
                
                gridColumnGap: `4rem`,
                gridRowGap: `1.5rem`,
                '@media (min-width: 1024px)': {
                  gridTemplateColumns: `1fr 1fr`,
                  padding: `0 2rem`,
                  gridRowGap: `3rem`,
                },
                'input': {
                  border: `1px solid gray`,
                  width: `100%`,
                  padding: `0.5rem 1rem`,
                  borderRadius: `0.5rem`,
                }
              }}>
                <div className='gfFieldBlock'>
                  <label for="first-name">First Name *</label>
                  <input id="first-name" {...register("firstName")} placeholder="John" />
                  <div className="errorMessage">
                    <small>{errors.firstName?.message}</small>
                  </div>
                </div>

                <div className='gfFieldBlock'>
                  <label for="last-name">Last Name *</label>
                  <input id="last-name" {...register("lastName")} placeholder="Smith" />
                  <div className="errorMessage">
                    <small>{errors.lastName?.message}</small>
                  </div>
                </div>

                <div className='gfFieldBlock'>
                  <label for="phone-number">Phone Number *</label>
                  <input id="phone-number" {...register("phoneNumber")} placeholder="912-739-3322" />
                  <div className="errorMessage">
                    <small>{errors.phoneNumber?.message}</small>
                  </div>
                </div>

                <div className='gfFieldBlock'>
                  <label for="card-number">Last 4 of Debit Card *</label>
                  <input id="card-number" {...register("cardNumber")} placeholder="7661" />
                  <div className="errorMessage">
                    <small>{errors.cardNumber?.message}</small>
                  </div>
                </div>
              </div>

              <div css={{
                display: `grid`,
                gridGap: `2rem`,
                margin: `0 auto`,
                //maxWidth: `60rem`,
                padding: `3rem 0`,
                
                '@media (min-width: 1024px)': {
                  gridTemplateColumns: `repeat(2, 1fr)`,
                  gridGap: `4rem`,
                  padding: `3rem 2rem 0 2rem`,
                  margin: `1.5rem auto`,
                },

                '.card': {
                  borderRadius: `0.5rem`,
                  position: `relative`,
                  backgroundColor: `#fff`,
                  '&:hover': { boxShadow: `5px 5px 10px rgba(0, 0, 0, 0.15)`, cursor: `pointer`}
                },
                '.radio': {
                  fontSize: `inherit`,
                  margin: `0`,
                  position: `absolute`,
                  right: `calc(1rem + 1px)`,
                  top: `calc(1rem + 1px)`,
                }, 
                '.plan-details': {
                  border: `1px solid gray`,
                  borderRadius: `0.5rem`,
                  cursor: `pointer`,
                  display: `flex`,
                  flexDirection: `column`,
                  padding: `1rem`,
                },
                '.card:hover .plan-details': {
                  border: `1px solid black`,
                }
                
              }}>
              
                <label class="card">
                  <input name="deliveryOption" class="radio" type="radio" checked value="Pickup" />
                  <span class="plan-details">
                    <SizedText as="span" smallSize="2.027" largeSize="4.624" css={{color: `#192851`, marginBottom: `1rem`}}>
                      <Icon icon={pickupIcon}/>
                    </SizedText>
                    <span css={{marginBottom: `0.5rem`}}>
                      <SizedText as="span" smallSize="1.602" largeSize="2" css={{color: `#192851`}}>Pickup Card</SizedText>
                      <SizedText as="span" smallSize="1" largeSize="1.266" css={{color: `#035ea9`, paddingLeft: `1rem`}}>$20</SizedText>
                    </span>
                    <Body>
                      Pickup your card instantly during regular business hours at the TCB Main Branch location, located at 121 West Main Street in Claxton Georgia 30417.  
                    </Body>
                  </span>
                </label>

                <label class="card">
                  <input name="deliveryOption" class="radio" type="radio" value="Mail" />
                  <span class="plan-details">
                    <SizedText as="span" smallSize="2.027" largeSize="4.624" css={{color: `#192851`, marginBottom: `1rem`}}>
                      <Icon icon={mailIcon} />
                    </SizedText>
                    <span css={{marginBottom: `0.5rem`}}>
                      <SizedText as="span" smallSize="1.602" largeSize="2" css={{color: `#192851`}}>Mail Card</SizedText>
                      <SizedText as="span" smallSize="1" largeSize="1.266" css={{color: `#035ea9`, paddingLeft: `1rem`}}>$15</SizedText>
                    </span>
                    <Body>
                      Get your card mailed directly to the address we have on file in about one week, and activate it by phone or on your mobile app. 
                    </Body>
                  </span>
                </label>

              </div>
              
              <div css={{ 
                textAlign: `left`, 
                display: `flex`, 
                margin: `3rem 0`, 
                '@media (min-width: 1024px)': {
                  textAlign: `left`, 
                  display: `flex`, 
                  margin: `3rem 2rem 0 2rem`,
                }
              }}>
                <input css={{alignSelf: `start`, margin: `0.3rem 2rem 0 1rem`, minWidth: `13px`}} type="checkbox" id="feeAck" name="feeAck" {...register("feeAck")}/>
                <label for="feeAck">
                  <Body styleOverrides={{textAlign: `justify`}}>
                      I acknowledge that the fee for the new instant issue card is $20.00 and new mailed card is $15.00. I understand that any card not picked up within 30 days will be destroyed and the fee will not be refunded. If I request a new card an additional 
                      fee will be charged for each additional card order. These fees may be waived in certain situations.  Please ask the customer service representative for details on the callback verification.
                  </Body>
                </label>
                <div className="errorMessage">
                    <small>{errors.feeAck?.message}</small>
                  </div>
              </div>

              <div css={{
                margin: `3rem 0`,
                '@media (min-width: 1024px)': {
                  margin: `3rem 2rem`,  
                }
              }}>
                <button 
                  type="submit"
                  disabled={!isDirty || !isValid} 
                  css={{
                    width: `100%`,
                    padding: `0.75rem 2rem`,
                    backgroundColor: `#2ecc71`,
                    marginRight: `2rem`,
                    borderRadius: `0.5rem`,
                    color: `#fff !important`,
                    textDecoration: `none`,
                    border: `1px solid #27ae60`,
                    cursor: `pointer`,
                    '&:disabled': {
                      backgroundColor: `#d2ded7`,
                      borderColor: `#91ad9d`
                    },
                  }}
                >
                  Order Card
                </button>
              </div>
          </form>
        </div>

          <div css={{display: `grid`, gridTemplateColumns: `1fr 1fr 1fr 1fr`, 'div': {height: `0.702rem`},}}>
            <div css={{backgroundColor: `#00b4e5`}}></div><div css={{backgroundColor: `#0376bd`}}></div><div css={{backgroundColor: `#005ea8`}}></div><div css={{backgroundColor: `#192851`}}></div>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout>
  )
}

export default OrderPage